import * as tf from '@tensorflow/tfjs';
import * as tfuse from '@tensorflow-models/universal-sentence-encoder'
import { useState, useEffect } from 'react';
import { FormControl, InputGroup, Button } from 'react-bootstrap';
import calculateCorrelation from 'calculate-correlation'

function Tensorflow(){
    // console.log("USE: ", tfuse)

    const [titleCorrelationBtnClicked, setTitleCorrelationBtnClicked] = useState(false)
    const [mainCorrelationBtnClicked, setMainCorrelationBtnClicked] = useState(false)
    const [title, setTitle] = useState("")
    const [main, setMain] = useState("")
    const [keywords, setKeywords] = useState("")
    // const [keywordEmbeddings, setkeywordEmbeddings] = useState()
    // const [titleEmbeddings, settitleEmbedings] = useState()
    // const [mainEmbeddings, setmainEmbeddings] = useState()

    const [kShape, setkShape] = useState(0)
    const [tShape, settShape] = useState(0)
    const [mShape, setmShape] = useState(0)

    // console.log("kShape: ",kShape)
    // console.log("tshape: ", tShape)
    const [answer, setAnswer] = useState("Add inputs to geneate correlation")

    const handleKeywords = (event) => {
        // console.log("keywords: ", event.target.value)
        const kList = event.target.value.replace(/\s/g, ',')
        // const updatedArray = kList.split(',')
        setKeywords(kList)
        // console.log("kList: ", kList)
    }
    const handleTitle = (event) => {
        // console.log("event: ", event.target.value)
        setTitle(event.target.value)
    }

    const handleMainInput = (event) => {
        setMain(event.target.value)
    }
    
    const inputs = {
        keywords: [keywords],
        title: title,
        main: main
    }

    //write async function to calculate correalation

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const titleKeywordCorrGen = async() => {
        setTitleCorrelationBtnClicked(true)
        setMainCorrelationBtnClicked(false)
        setAnswer("Calculating...")
        try {
            let model = await tfuse.load()
            let keywordEmbeddings = model.embed(inputs.keywords)
            let titleEmbeddings = model.embed(inputs.title)

            for (let i = 0; i < inputs['title'].length; i++) {
                for (let j = 0; j < inputs['keywords'][0].length; j++){
                    console.log("inside loop")
                }
            }
    
            // console.log("keywordEmbeddings: ", keywordEmbeddings)
            // console.log("Keywordshape: ", (await keywordEmbeddings).shape)
            
            // setkeywordEmbeddings(keywordEmbeddings)
            // settitleEmbedings(titleEmbeddings)
            // setmainEmbeddings(null)

            const kShape = (await keywordEmbeddings).shape
            const kTensor = tf.tensor1d(kShape)
            // console.log("kShape: ",kShape)
            console.log("kTensor: ", kTensor)
            
            const tShape = (await titleEmbeddings).shape
            const tTensor = tf.tensor1d(tShape)
            // console.log("tShape: ",tShape)
            console.log("tTensor: ", tTensor)
            
            // const corrKT = dot(kTensor, tTensor)
            // console.log("corrKT: ", corrKT)
            // setAnswer("Not set up yet")
            setkShape(kShape)
            settShape(tShape)
            correalationKT()
        }
        catch(error){
            console.log(error)
        }
    }

    const correalationKT = () => {
        const keywordsForCorrelation = [kShape[0], tShape[1]]
        const titleForCorrelation = [kShape[0], tShape[1]]
        const config = {
            string: true,
            decimals: 5,
          };
        // const mainForCorrelation = [mShape[0],mShape[1]]    
        const answer = calculateCorrelation(keywordsForCorrelation, titleForCorrelation, config).toString()
        console.log("answer: ", answer)
        setAnswer(answer)
    }

    const mainKeywordCorrGen = async() => {
        setMainCorrelationBtnClicked(true)
        setTitleCorrelationBtnClicked(false)
        setAnswer("Calculating...")
        try {
            let model = await tfuse.load()
            let keywordEmbeddings = model.embed(inputs.keywords)
            let mainEmbeddings = model.embed(inputs.main)
            // console.log("keywordEmbeddings: ", keywordEmbeddings)
            // console.log("Keywordshape: ", (await keywordEmbeddings).shape)

            //kShape is shape of the keywords
            const kShape = (await keywordEmbeddings).shape
            // const kTensor = tf.tensor1d(kShape)
            // console.log("kShape: ",kShape)
            // console.log("kTensor: ", kTensor)

            const mShape = (await mainEmbeddings).shape
            // const mTensor = tf.tensor1d(mShape)
            // console.log("mShape: ",mShape)
            // console.log("mTensor: ", mTensor)
            
            // setkeywordEmbeddings(keywordEmbeddings)
            // setmainEmbeddings(mainEmbeddings)        
            // settitleEmbedings(null)
            // setAnswer("Not set up yet")
            setkShape(kShape)
            setmShape(mShape)
            correlationKM()
        }
        catch(error) {
            console.log(console.error())
        }
    }

    const correlationKM = () => {
        const keywordsForCorrelation = [kShape[0], kShape[1]]
        // const titleForCorrelation = [tShape[0], tShape[1]]
        const mainForCorrelation = [mShape[0],mShape[1]]    
        const answer = calculateCorrelation(keywordsForCorrelation, mainForCorrelation)
        setAnswer(answer)
    }

    useEffect(() => {
        titleKeywordCorrGen()
        mainKeywordCorrGen()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // console.log("keywordEmbeddings: ", keywordEmbeddings)    
    // console.log("titleEmbeddings: ", titleEmbeddings)
    // console.log("mainEmbeddings: ", mainEmbeddings)

    // const keywordQuery =  keywordEmbeddings
    // const titleQuery = titleEmbeddings
    // const mainQuery = mainEmbeddings

    // console.log("keywirdQuery: ",keywordQuery)
    // console.log("titleQuery: ", titleQuery)
    // console.log("mainQry: ",mainQuery)
    
    // const arrayOfKeywords = inputs.keywords.map(k => k)
    // console.log(arrayOfKeywords)

    return (
        <div>
            <h1>SEO APP</h1>
            <div className="inputWrapper">
                <InputGroup.Text
                    className="inputs"
                    name="keywords"
                    as="textarea" 
                    placeholder="keywords" 
                    onChange={handleKeywords}
                />
                <InputGroup.Text
                    className="inputs"
                    name="title"
                    as="textarea" 
                    placeholder="title"
                    onChange={handleTitle}
                />
                <FormControl
                    className="inputs"
                    name="content"
                    as="textarea" 
                    placeholder="content"
                    onChange={handleMainInput}
                />
            </div>
            <div>
                <Button onClick={titleKeywordCorrGen}>Generate Correlation of Keywords and Title</Button>
                {" "}
                <Button onClick={mainKeywordCorrGen}>Generate Correlation of Keywords and Main Content</Button>
            </div>
            <div>
                <strong>Answer</strong> : {answer}
            </div>
            <hr/>
            <div>
                <strong>Entered Keyword Values :</strong>
                {inputs.keywords.map((keywords, index) => 
                    <p>
                        {inputs.keywords[index]}
                    </p>
                )}
            </div>
            <hr/>
            <div>
                <strong>Entered Title :</strong> {inputs.title}
            </div>
            <hr/>
            <div>
                <strong>Entered Content : </strong>{inputs.main}
            </div>
            <hr/>
            <div>{
                titleCorrelationBtnClicked && kShape && tShape ?
                <div>
                <strong>Shape of the keyword:</strong> [{kShape[0]}, {kShape[1]}] {" | "} 
                <strong>Shape of the title: </strong>[{tShape[0]}, {tShape[1]}] {" | "} 
                {/* <strong>Shape of the Main Content:</strong>[{mShape[0]},{mShape[1]}] */}
                </div> 
                :
                mainCorrelationBtnClicked && kShape && mShape ?
                <div>
                <strong>Shape of the keyword:</strong> [{kShape[0]},{kShape[1]}] {" | "} 
                {/* <strong>Shape of the title: </strong>[{tShape[0]},{tShape[1]}] {" | "}  */}
                <strong>Shape of the Main Content:</strong>[{mShape[0]},{mShape[1]}]
                </div>  
                :
                keywords === "" && title === "" && main === "" ?
                <div>Add and wait for the calculation</div>
                : null
                }
            </div>
        </div>
    )
}

export default Tensorflow;
 